import { jsxs as d, jsx as m } from "react/jsx-runtime";
import { forwardRef as W, useRef as j, useState as B } from "react";
import { u as i } from "./index-6a632112.mjs";
import { s as t, k as R, d as q, e as O, r as E, l as g } from "./themes-5f0b3c3d.mjs";
import { l as M } from "./lineHeights-72d3110c.mjs";
import { t as o } from "./textStyles-42cab346.mjs";
import { u as X } from "./uniqueId-321287e8.mjs";
import { useAccessibilityProps as G } from "./accessibility.js";
import { L as J } from "./label-3b996c7d.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
const K = "28px", N = "TextArea", Q = i.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: ${t["2x"]};
  font-family: ${R};
`, U = i.textarea`
  display: flex;
  min-height: 120px;
  padding: ${t["1x"]} ${t["3x"]};
  align-items: flex-start;
  gap: ${t["2x"]};
  align-self: stretch;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-width: 250px;
  font-family: ${q.body};
  font-weight: ${O.regular.S.fontWeight};
  border: 1px solid
    ${(e) => e.$isInvalid ? e.theme.colors.status.errorHoverColor : e.theme.components.textArea.borderColorFilled};
  border-radius: ${E["2x"]};
  background-color: ${(e) => e.theme.components.textArea.backgroundColor};
  color: ${(e) => e.theme.components.textArea.textColorFilled};

  letter-spacing: ${g[0]};
  line-height: ${M.medium};
  font-size: ${o.body.regular.l.fontSize};

  &::placeholder {
    opacity: 1; /* Firefox */
    color: ${(e) => e.theme.components.textArea.textColorPlaceholder};
  }

  &:hover {
    border-color: ${(e) => e.$isInvalid ? e.theme.colors.status.errorHoverColor : e.theme.components.textArea.outlineColorFocusHover};
  }

  &:focus-within {
    outline: 1px solid
      ${(e) => e.$isInvalid ? e.theme.colors.status.errorHoverColor : e.theme.components.textArea.outlineColorFocusHover};
    border-color: ${(e) => e.$isInvalid ? e.theme.colors.status.errorHoverColor : e.theme.components.textArea.outlineColorFocusHover};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${(e) => e.theme.components.textArea.backgroundColorDisabled};
    border-color: ${(e) => e.theme.components.textArea.borderColorDisabled};
    color: ${(e) => e.theme.components.textArea.textColorDisabled};

    &::-webkit-input-placeholder {
      color: ${(e) => e.theme.components.textArea.textColorDisabled};
    }

    &::-moz-placeholder {
      color: ${(e) => e.theme.components.textArea.textColorDisabled};
    }
  }

  ${({ $textSize: e }) => {
  if (e === "small")
    return `
        font-size: ${o.body.medium.s.fontSize};
        padding-left: ${t["2x"]};
        padding-right: ${t["3x"]};
        line-height: ${o.body.medium.s.lineHeight};
        `;
  if (e === "medium")
    return `
        font-size: ${o.body.medium.m.fontSize};
        padding-left: ${t["3x"]};
        padding-right: ${t["3x"]};
        line-height: ${o.body.medium.m.lineHeight};
        `;
  if (e === "large")
    return `
        font-size: ${o.body.medium.l.fontSize};
        padding-left: ${t["3x"]};
        padding-right: ${t["3x"]};
        line-height: ${K};
         `;
}}
`, Y = `
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;`, b = i.span`
  display: flex;
  color: ${(e) => e.$isInvalid ? e.theme.colors.status.errorHoverColor : e.theme.components.textArea.textColorPlaceholder};
  font-size: ${o.body.medium.s.fontSize};
  letter-spacing: ${g[0]};
  line-height: ${o.body.medium.s.lineHeight};
  margin-top: ${t["2x"]};
  ${Y};
  overflow: hidden;
`, Z = i(b)`
  white-space: nowrap;
  overflow: visible;
`, V = i.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${t["2x"]};
`, Ae = W(
  ({
    onChange: e,
    maxCharacters: l,
    defaultValue: c,
    role: y = "textbox",
    disabled: p,
    isInvalid: r,
    placeholder: v,
    helperText: C,
    value: n,
    textareaRef: A,
    textSize: w = "medium",
    children: ee,
    isRequired: a = !1,
    className: H,
    isIncremental: T = !1,
    accessibilityOptions: I = {},
    labelProp: z,
    infoProp: D,
    trailingText: S,
    ...h
  }, k) => {
    const s = j(X(h.id ?? N)), x = `${s.current}_message_id`, f = `${s.current}_label_id`, F = G("input", {
      ariaDisabled: p,
      ariaInvalid: r,
      ariaRequired: a,
      ariaLabelledBy: `${f} ${x}`,
      ...I
    }), [P, L] = B(n || c || ""), u = (n ?? P).length, _ = ($) => {
      L($.target.value), e?.($);
    };
    return /* @__PURE__ */ d(Q, { className: H, ref: k, children: [
      /* @__PURE__ */ m(
        J,
        {
          labelProp: {
            showRequiredIndicator: a,
            id: f,
            ...z
          },
          infoProp: {
            infoText: "",
            infoType: "tooltip",
            popupTipHeader: "Popup Header",
            ...D
          },
          trailingText: S
        }
      ),
      /* @__PURE__ */ m(
        U,
        {
          disabled: p,
          value: n,
          placeholder: v,
          defaultValue: c,
          ref: A,
          role: y,
          maxLength: l,
          onChange: _,
          $isInvalid: r,
          $textSize: w,
          "aria-required": a,
          "aria-invalid": r || void 0,
          ...h,
          id: s.current,
          ...F
        }
      ),
      /* @__PURE__ */ d(V, { children: [
        /* @__PURE__ */ m(
          b,
          {
            ...r && {
              "aria-live": "polite",
              role: "alert"
            },
            id: x,
            "data-testid": "helper-text",
            $isInvalid: r,
            children: C
          }
        ),
        l !== void 0 && /* @__PURE__ */ d(Z, { children: [
          T ? u : l - u,
          "/",
          l
        ] })
      ] })
    ] });
  }
);
export {
  Ae as TextArea
};
